<template>
    <!-- 总平台管理－场地管理-特殊营业时间 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'specialBusiness')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY-MM-DD"
                            v-decorator="['businessDate']"
                        />
                    </a-form-item>
                    <a-form-item label="开闭店">
                        <a-select allowClear placeholder="请选择" v-decorator="['businessState']">
                            <a-select-option value="1">开店</a-select-option>
                            <a-select-option value="0">闭店</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :title="shopNameTitle">
                <a-button slot="extra" class="mb16" type="primary" icon="plus" @click="toSpecialBusinessSet()">新建</a-button>
                <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                :loading="spinning"
                @change="changePage"
                :rowKey="record => record.id"
                >
                <span slot="businessState" slot-scope="a,row">{{['闭店','开店'][row.businessState]}}</span>
                <span slot="action" slot-scope="a,row">
                    <a class="text-primary" @click="openUpdate(row)">编辑<a-divider type="vertical"/></a>
                    <a-popconfirm title="操作后将立即生效，是否确认删除？" @confirm="deleteDate(row.id)" okText="是" cancelText="否">
                        <a class="text-primary">删除</a>
                    </a-popconfirm>
                </span>
                </a-table>
            </a-card>
            <a-modal centered title="营业时间编辑" :width="680" :visible="visible" @cancel="close" @ok="batchSetDate">
                <a-form :form="formModal" class="mt24">
                    <a-form-item label="日期" :labelCol="{span: 5}" :wrapperCol="{span: 12}">
                        <a-date-picker v-decorator="['date']" disabled />
                    </a-form-item>
                    <a-form-item label="开闭店状态" required :labelCol="{span: 5}" :wrapperCol="{span: 12}">
                        <a-radio-group v-decorator="['businessState']" @change="onChangebusinessState" >
                            <a-radio :value="1">开店</a-radio>
                            <a-radio :value="0">闭店</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="营业时间" v-show="isShow" required :labelCol="{span: 5}" :wrapperCol="{span: 12}" style="margin-bottom: 0">
                        <a-input-group compact>
                            <a-form-item class="group-left" style="display: inline-block; width: 45%;">
                                <a-time-picker format="HH:mm" style="width: 100%;" v-decorator="['startTime',{rules: [{required: isShow, message: '请选择开始营业时间'}]}]" placeholder="开始营业时间">
                                    <span slot="suffixIcon"></span>
                                </a-time-picker>
                            </a-form-item>
                            <a-input
                                style="width: 10%; border-left: 0;border-right: 0; pointer-events: none; backgroundColor: #fff"
                                placeholder="~"
                                disabled
                            />
                            <a-form-item class="group-right" style="display: inline-block; width: 45%;">
                                <a-time-picker format="HH:mm" style="width: 100%;" v-decorator="['endTime',{rules: [{required: isShow, message: '请选择结束营业时间'}]}]" placeholder="结束营业时间"></a-time-picker>
                            </a-form-item>
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="说明" :labelCol="{span: 5}" :wrapperCol="{span: 12}">
                        <a-input v-decorator="['remark',{rules: [{ message: '请输入(50字以内)',max: 50}]}]" placeholder="请输入（0-50字）" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "specialBusiness",
        components: {},
        props: {},
        data() {
            const columns = [
            {
                title: "日期",
                dataIndex: "businessDate"
            },
            {
                title: "星期",
                dataIndex: "weekInfo"
            },
            {
                title: "开闭店状态",
                dataIndex: "businessState",
                scopedSlots: { customRender: "businessState" }
            },
            {
                title: "营业时间",
                dataIndex: "workTime"
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
            ];
            return {
                form: this.$form.createForm(this),
                formModal: this.$form.createForm(this),
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                visible: false,
                isShow: true,
                shopNameTitle: '',
                currentShopId: '',
                spinning: false,
            };
        },
        computed: {
            ...mapGetters(["shopId","shopName"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                this.spinning = true;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.shopId = this.currentShopId;
                    const businessDate = values['businessDate'] ? values['businessDate'] : []
                    values.businessStartDate = businessDate.length > 0 ? businessDate[0].format('YYYY-MM-DD') : undefined
                    values.businessEndDate = businessDate.length > 0 ? businessDate[1].format('YYYY-MM-DD') : undefined
                    delete values.businessDate
                    this.$api.totalPlatform.queryBusinessHours({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                        this.spinning = false;
                    }).catch(err => {
                        this.spinning = false;
                    })
                });
            },
            openUpdate(row) {
                this.visible = true;
                this.isShow = row.businessState == 1;
                this.$nextTick(() => {
                    this.formModal.setFieldsValue({
                        date: row.businessDate,
                        businessState: row.businessState,
                        startTime: row.businessState ? this.$moment(row.businessDate + ' ' + row.workTime.split('-')[0]) : null,
                        endTime: row.businessState ? this.$moment(row.businessDate + ' ' + row.workTime.split('-')[1]) : null,
                        remark: row.remark,
                    })
                })
            },
            onChangebusinessState(e) {
                this.isShow = e.target.value === 1;
            },
            batchSetDate() {
                let _this = this;
                _this.formModal.validateFields((err, values) => {
                    if (err) return;
                    if(_this.isShow && values.endTime <= values.startTime) {
                        _this.$message.error('结束营业时间需大于开始营业时间，请重新选择')
                        return
                    }
                    let businessHoursSetOneDtos = [{
                        businessHoursDateStart: _this.$moment(values.date).format('YYYY-MM-DD'),
                        businessHoursDateEnd: _this.$moment(values.date).format('YYYY-MM-DD'),
                        businessState: values['businessState'],
                        remark: values['remark'],
                        businessHoursTimeRangeDtos: [{
                            startTime: _this.isShow ? values.startTime.format('HH:mm') : '',
                            endTime: _this.isShow ? values.endTime.format('HH:mm') : '',
                        }],
                    }]
                    _this.$api.totalPlatform.batchSetBusinessHours({
                        body: {
                            businessHoursSetOneDtos: businessHoursSetOneDtos,
                            suitShopIdList: [_this.shopId]
                        }
                    }).then(res => {
                        _this.$message.success('操作成功');
                        this.getList();
                        this.close();
                    });
                });
            },
            close() {
                this.visible = false;
                this.form.resetFields();
            },
            // 跳转至特殊营业时间设置页
            toSpecialBusinessSet() {
                this.$router.push({
                    name: "addSpecialBusiness",
                    query: { id: this.currentShopId, shopName: this.shopNameTitle}
                });
            },
            deleteDate(id) {
                this.$api.totalPlatform.delBusinessHours({
                    params: {id: id}
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                });
            }
        },
        mounted() {
            this.shopNameTitle = this.$route.query.shopName;
            this.currentShopId = this.$route.query.id;
            this.getList()
        },
        watch: {
            $route() {
                this.getList();
            },
            shopId() {
                this.shopNameTitle = this.shopName;
                this.currentShopId = this.shopId;
                this.getList()
            }
        }
    };
</script>
<style lang="scss">

        .group-right {
            .ant-time-picker-input {
                border-left: none;
                border-radius: 0 4px 4px 0;
            }
        }
</style>